module.exports = __webpack_public_path__ + "img/0x4F43fFd28d00999d3C813b20dEE9f315757c6E1B.21242a56.png";